import { Helmet } from "react-helmet-async";
import "./style.css";
import NavbarTop from "../../components/NavbarTop";
import { useEffect, useRef, useState, useCallback } from "react";
import Spinner, { LoadingThreeCircle } from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import PostList from "../../components/Post/PostList";
import { useAuth } from "../../global-components/src";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { errorMessage } from "../../utils/TextManagerTwo";
import { useMessage } from "../../global-components/src";
import FormVerifyEmail from "../../components/FormVerifyEmail/FormVerifyEmail";
import OpenImg from "../../components/Modals/OpenImg/OpenImg";
import ModalPostLikes from "../Posts/PostLikes/ModalPostLikes";
// import ModalPostComments from "../Posts/PostLikes/ModalPostComments";
import { getViewedAds, updateViewedAds } from "../../utils/ads";
import { BUCKET_PACOCA_URL, PACOCA_API_URL } from "../../global-components/src/utils/vars";
import ModalCommentsBottom from "../../components/Modals/comments/comments-bottom";
import ModalComments from "../../components/Modals/comments/modal-comments";
import { LeftContent, RightContent, SponsoredContent } from "../../global-components/src/components/screen/left-content";
import { useTranslation } from 'react-i18next';

const Reposts: React.FC = () => {
    const { id: postId } = useParams();
    const [posts, setPosts] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [end, setEnd] = useState(false);
    const [page, setPage] = useState(1);
    const [cursor, setCursor] = useState<number | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);
    const endOfListRef = useRef<HTMLDivElement | null>(null);
    const [feedType, setFeedType] = useState("feed");
    const [error, setError] = useState("");
    const { user, isAuthenticated, token } = useAuth();
    const userImg = user?.img_account ? BUCKET_PACOCA_URL + "/" + user?.img_account.replace(/\.\.\//g, '') : "/img/img-account.png";
    const navigate = useNavigate();
    const hasRun = useRef(false);
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const location = useLocation();
    const pageUrl = `${window.location.origin}${location.pathname}`;
    const ogImage = "/img/pacoca-sem-braco-fundo-rounded.png";
    const [showModalLikes, setShowModalLikes] = useState(false);
    const [showModalComments, setShowModalComments] = useState(false);
    const [idPostSelected, setIdPostSelected] = useState<number | null>(null);
    const [imgPath, setImgPath] = useState("");
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Rede Social Paçoca",
        "url": pageUrl,
        "description": "Paçoca é uma rede social inovadora que permite você se conectar com pessoas ao redor do mundo, fazer novos amigos e compartilhar momentos.",
        "image": ogImage,
        "publisher": {
            "@type": "Organization",
            "name": "Paçoca Inc.",
            "logo": {
                "@type": "ImageObject",
                "url": ogImage
            }
        }
    };

    const changeFeedType = (type: string) => {
        if (loading) return; // Ignora se já está carregando
        setEnd(false);
        setFeedType(type);
        setPage(1); // Mude para 1 para a primeira página
        setPosts([]);
    }

    const loadPosts = async (cursorParam: number | null = cursor) => {
        // anuncios já vistos
        const viewedAds = getViewedAds();
        const viewedAdsParam = viewedAds.join(',');
        let url =  `${PACOCA_API_URL}/posts?feedType=${feedType}&viewed_ads=${viewedAdsParam}&repost=${postId}`;

        if(cursorParam){
            url += `&cursor=${cursorParam}`;
        }

        if (loading || end) return;
        setLoading(true);

        try {
            const response = await axios.get(url, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            const data = response.data.posts;
            setCursor(response.data.next_cursor);

            if (data.length > 0) {
                setPosts((prev) => {
                    const existingIds = new Set(prev.map(post => post?.id)); // Cria um Set com os IDs existentes
                    const newPosts = data.filter((post: { id: any; }) => !existingIds.has(post?.id)); // Filtra apenas posts novos
                    if (newPosts.length === 0) return prev; // Se não houver novos posts, mantém o estado atual
                    const updatedPosts = [...prev, ...newPosts];
                    updateViewedAds(data);
                    return updatedPosts;
                });
            } else {
                setEnd(true);
            }

        } catch (err: any) {
            console.error("Failed to load posts:", err);
            setEnd(true);
            if (err.status == 429)
                setMessage(t("generics.errors.tooManyRequestsGeneric"), "warning")
        } finally {
            setLoading(false);
        }
    };

    const observerCallback = useCallback(
        (entries: IntersectionObserverEntry[]) => {
            const target = entries[0];
            if (target.isIntersecting && !loading && !end) {
                setPage((prev) => prev + 1);
            }
        },
        [loading, end]
    );

    useEffect(() => {
        if (!hasRun.current || page != 1) {
            loadPosts(cursor);
            // Salva a página atual no localStorage
            hasRun.current = true;

        }
    }, [page, feedType]);

    useEffect(() => {
        if (endOfListRef.current) {
            observerRef.current = new IntersectionObserver(observerCallback, {
                root: null,
                rootMargin: "200px",
                threshold: 0.1
            });

            observerRef.current.observe(endOfListRef.current);
        }

        return () => observerRef.current?.disconnect();
    }, [observerCallback]);

     useEffect(() => {
        const handleModalClose = () => {
            setShowModalLikes(false)
            setShowModalComments(false)
            setIdPostSelected(null)
        };
    
        const modalLikesElement = document.getElementById("modal-likes");
        const modalCommentsElement = document.getElementById("modal-comments");

        if (modalLikesElement) 
            modalLikesElement.addEventListener("hidden.bs.modal", handleModalClose);

        if (modalCommentsElement) 
            modalCommentsElement.addEventListener("hidden.bs.modal", handleModalClose);
    
        return () => {
            if (modalLikesElement)
                modalLikesElement.removeEventListener("hidden.bs.modal", handleModalClose);

            if (modalCommentsElement)
                modalCommentsElement.removeEventListener("hidden.bs.modal", handleModalClose);
        };
    }, []);

    return (
        <div className="container container-feed" style={{ paddingTop: "60px", minWidth: "100%!important", minHeight: "100dvh" }}>
            <Helmet>
                <title>Paçoca</title>
                <meta name="description" content="Paçoca é uma rede social inovadora que permite você se conectar com pessoas ao redor do mundo, fazer novos amigos e compartilhar momentos. Junte-se à Paçoca hoje mesmo!" />
                <meta name="keywords" content="Paçoca, rede social, fazer amigos, conexões online, comunidade digital, rede social brasileira, criar perfil online, compartilhar momentos" />
                <meta name="author" content="Paçoca Inc." />
                <meta property="og:title" content="Paçoca - A Rede Social para Conectar Pessoas e Fazer Amigos" />
                <meta property="og:description" content="Conecte-se com pessoas e faça novos amigos na Paçoca, a rede social inovadora e divertida." />
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Paçoca - A Rede Social para Conectar Pessoas e Fazer Amigos" />
                <meta name="twitter:description" content="Junte-se à Paçoca e faça novos amigos. Acesse agora a rede social que conecta pessoas ao redor do mundo." />
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                {/* Schema Markup */}
                <script type="application/ld+json">{JSON.stringify(schemaMarkup)}</script>
            </Helmet>

            <LeftContent/>
            <RightContent>
                <SponsoredContent/>
            </RightContent>

            <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-4" style={{position: "relative"}}>
                    <NavbarTop title="Reposts" />
                    <h1 className="title-hashtag none-pc"> &nbsp; </h1>

                    {user && !user?.email_verified_at && isAuthenticated ? (
                        <div className="card card-post card-verify-email-button" style={{ margin: 0 }}>
                            <FormVerifyEmail />
                        </div>
                    ) : null}

                    <PostList onOpenComments={(idPost) => {setShowModalComments(true); setIdPostSelected(idPost)}} onOpenLikes={(idPost) => {setShowModalLikes(true); setIdPostSelected(idPost)}} posts={posts} setPosts={setPosts} />

                    <div ref={endOfListRef} style={{ height: "20px" }}></div>

                    {loading && (
                        <div className="d-flex" style={{ justifyContent: "center", marginTop: "40px" }}>
                            <LoadingThreeCircle/>
                            {/* <Spinner className="text-primary" size="20" borderWidth="2" /> */}
                        </div>
                    )}

                    {end && (
                        <div style={{ textAlign: "center", marginTop: "20px", display: "flex", justifyContent: "center" }}>
                            <div id="text-carregar" style={{ textAlign: "center", marginTop: "20px" }}>
                                Fim dos reposts
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <OpenImg id={`modal-img`} path={imgPath} />
            <ModalPostLikes idPostSelected={idPostSelected} show={showModalLikes} />
            {window.innerWidth <= 850 ? <ModalCommentsBottom setOpen={setShowModalComments} open={showModalComments} idPostSelected={idPostSelected}/> : <ModalComments idPostSelected={idPostSelected} show={showModalComments} />}
        </div>
    );
};

export default Reposts;
